import React from 'react'

class Logs extends React.Component {
  render () {
    return (
      <div className="">Logs</div>
    )
  }
}

export default Logs


// WEBPACK FOOTER //
// ./src/views/project/projectComponents/logs/Logs.js